"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.addBatch = addBatch;
exports.addBatchOrderList = addBatchOrderList;
exports.addOrderList = addOrderList;
exports.addProcess = addProcess;
exports.cancelByReviewed = cancelByReviewed;
exports.clearOperator = clearOperator;
exports.default = void 0;
exports.del = del;
exports.edit = edit;
exports.get = get;
exports.getInfo = getInfo;
exports.getInfoByWorkOrderNumber = getInfoByWorkOrderNumber;
exports.getInfoV2 = getInfoV2;
exports.getJudgment = getJudgment;
exports.getJudgmentUsers = getJudgmentUsers;
exports.getOrderList = getOrderList;
exports.getPackageNumber = getPackageNumber;
exports.getProcess = getProcess;
exports.getProduceAres = getProduceAres;
exports.getSjInfo = getSjInfo;
exports.getUserByDeptName = getUserByDeptName;
exports.getUserListByName = getUserListByName;
exports.ifUpdate = ifUpdate;
exports.migrate = migrate;
exports.queryJudgment = queryJudgment;
exports.queryProduceInfo = queryProduceInfo;
exports.statement = statement;
exports.upDataByBasic = upDataByBasic;
exports.updata = updata;
exports.updataByJudgment = updataByJudgment;
exports.updateByReviewed = updateByReviewed;

var _request = _interopRequireDefault(require("@/utils/request"));

function add(data) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp',
    method: 'post',
    data: data
  });
}

function get(rowId) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp?rowId=' + rowId,
    method: 'get'
  });
}

function getInfo(rowId) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/queryInfo?rowId=' + rowId,
    method: 'get'
  });
}

function getInfoV2(rowId) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/queryInfoV2?rowId=' + rowId,
    method: 'get'
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/cmsWorkOrder/',
    method: 'delete',
    data: ids
  });
}

function migrate(data) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/migrate',
    method: 'put',
    data: data
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp',
    method: 'put',
    data: data
  });
}

function updata(data) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/updataCms',
    method: 'post',
    data: data
  });
}

function upDataByBasic(data) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/upDataByBasic',
    method: 'post',
    data: data
  });
}

function updataByJudgment(data) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/updataByJudgment',
    method: 'post',
    data: data
  });
}

function addProcess(data) {
  return (0, _request.default)({
    url: '/api/CmsWorkOrderProcessController/addProcess',
    method: 'post',
    data: data
  });
}

function getOrderList(data) {
  return (0, _request.default)({
    url: '/api/CmsWorkOrderListController/get',
    method: 'post',
    data: data
  });
}

function addOrderList(data) {
  return (0, _request.default)({
    url: '/api/CmsWorkOrderListController/addOrderList',
    method: 'post',
    data: data
  });
}

function getProcess(data) {
  return (0, _request.default)({
    url: '/api/CmsWorkOrderProcessController/get',
    method: 'post',
    data: data
  });
}

function queryProduceInfo(rowId) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/queryProduceInfo?rowId=' + rowId,
    method: 'get'
  });
}

function getProduceAres() {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/getProduceAres',
    method: 'get'
  });
}

function queryJudgment(rowId) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/queryJudgment?rowId=' + rowId,
    method: 'get'
  });
}

function getSjInfo(contractNo) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/getSjInfo?contractNo=' + contractNo,
    method: 'get'
  });
}

function getJudgmentUsers(id) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/getUserByJudgment?id=' + id,
    method: 'get'
  });
}

function addBatch(data) {
  return (0, _request.default)({
    url: '/api/cmsFollowUp/addBatch',
    method: 'post',
    data: data
  });
}

function ifUpdate(rowId) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/ifUpdate?rowId=' + rowId,
    method: 'get'
  });
}

function clearOperator(rowId) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/clearOperator?rowId=' + rowId,
    method: 'get'
  });
}

function cancelByReviewed(rowId) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/cancelByReviewed?rowId=' + rowId,
    method: 'get'
  });
}

function updateByReviewed(rowId) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/updateByReviewed?rowId=' + rowId,
    method: 'get'
  });
}

function addBatchOrderList(data) {
  return (0, _request.default)({
    url: 'api/CmsWorkOrderListController/addBatchOrderList',
    method: 'post',
    data: data
  });
}

function getUserByDeptName(deptName) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/getUserByDeptName?deptName=' + deptName,
    method: 'get'
  });
}

function getUserListByName(id) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/getUserListByName?id=' + id,
    method: 'get'
  });
}

function getInfoByWorkOrderNumber(workOrderNumber) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/getInfoByWorkOrderNumber?workOrderNumber=' + workOrderNumber,
    method: 'get'
  });
}

function getPackageNumber(workOrderNumber) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/getPackageNumber?workOrderNumber=' + workOrderNumber,
    method: 'get'
  });
}

function getJudgment() {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/getJudgment',
    method: 'get'
  });
}

function statement(workOrderNumber) {
  return (0, _request.default)({
    url: 'api/cmsFollowUp/statement?workOrderNumber=' + workOrderNumber,
    method: 'get',
    workOrderNumber: workOrderNumber
  });
}

var _default = {
  getSjInfo: getSjInfo,
  statement: statement,
  upDataByBasic: upDataByBasic,
  getProduceAres: getProduceAres,
  getJudgmentUsers: getJudgmentUsers,
  getJudgment: getJudgment,
  getUserListByName: getUserListByName,
  updataByJudgment: updataByJudgment,
  getPackageNumber: getPackageNumber,
  migrate: migrate,
  getInfoByWorkOrderNumber: getInfoByWorkOrderNumber,
  getInfoV2: getInfoV2,
  getUserByDeptName: getUserByDeptName,
  cancelByReviewed: cancelByReviewed,
  updateByReviewed: updateByReviewed,
  clearOperator: clearOperator,
  ifUpdate: ifUpdate,
  addBatch: addBatch,
  queryJudgment: queryJudgment,
  add: add,
  edit: edit,
  del: del,
  updata: updata,
  addProcess: addProcess,
  getOrderList: getOrderList,
  addOrderList: addOrderList,
  getProcess: getProcess,
  queryProduceInfo: queryProduceInfo,
  getInfo: getInfo,
  addBatchOrderList: addBatchOrderList
};
exports.default = _default;